module.exports = __webpack_public_path__ + "img/brian_pointsguy.408aa8c1.jpg";